'use strict';

exports.__esModule = true;
exports.Consumer = exports.Provider = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _createReactContext = require('create-react-context');

var _createReactContext2 = _interopRequireDefault(_createReactContext);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var BreakpointsContext = _react2.default.createContext ? _react2.default.createContext() : (0, _createReactContext2.default)();
var Provider = BreakpointsContext.Provider,
    Consumer = BreakpointsContext.Consumer;
Provider.displayName = 'ReactBreakpoints.Provider';
Consumer.displayName = 'ReactBreakpoints.Consumer';
exports.Provider = Provider;
exports.Consumer = Consumer;
exports.default = BreakpointsContext;